export const usePickerLabel = timeDurationMin => {
  const hours = Math.floor(timeDurationMin / 60)
  const minutes = timeDurationMin % 60

  return `${hours}h ${minutes > 0 ? `${minutes}min` : ""}`
}
